// 用户角色枚举
export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "ADMIN";
    UserRole["PRE_SALES"] = "PRE_SALES";
    UserRole["SALES"] = "SALES";
    UserRole["DESIGNER"] = "DESIGNER";
    UserRole["MODELER"] = "MODELER";
    UserRole["TRACKER"] = "TRACKER";
    UserRole["DATA_ARCHIVIST"] = "DATA_ARCHIVIST";
})(UserRole || (UserRole = {}));
// 用户状态枚举
export var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "ACTIVE";
    UserStatus["INACTIVE"] = "INACTIVE";
    UserStatus["LOCKED"] = "LOCKED";
    UserStatus["DELETED"] = "DELETED";
})(UserStatus || (UserStatus = {}));
